/**
 * Group Service - Handles API interactions for group management.
 */

import { get, post, put, del } from '../utils/apiUtils';

const API_URL = '/api/v1/mms_persistence/user_group';
const API_GROUP_URL = `api/v1/mms_ai_usermanagement/user/group`;


/**
 * Get Groups
 * @returns {Promise<Object>} Registration response
 */
export const fetchUsersGropus = async () => {
  try {
    const response = await get(`${API_URL}`);
    
    return response;
  } catch (error) {
    console.error('Error while fetching users:', error);
    throw error;
  }
};


export const updateUserGroup = async (groupData) => {
    try {
      const response = await put(`${API_GROUP_URL}`, groupData);
      return response;
    } catch (error) {
    console.error('Error while updating group:', error);
    throw error;
    }
}

export const createUserGroup = async (groupData) => {
    try {
      const response = await post(`${API_GROUP_URL}`, groupData);
      return response;
    } catch (error) {
    console.error('Error while creating group:', error);
    throw error;
    }
}